import type { FieldCommitMode } from "./contracts";

export type FieldSaveMode = "confirm" | "debounce" | "inline";

/**
 * Maps definition/session `commit` to TextareaField `saveMode` chrome.
 * EditableField footer owns confirm UX when session shell is present;
 * bare TextareaField uses the returned saveMode.
 */
export function commitToSaveMode(
	commit?: FieldCommitMode,
): FieldSaveMode {
	switch (commit) {
		case "confirm":
			return "confirm";
		case "immediate":
			return "debounce";
		case "live":
			return "inline";
		default:
			return "inline";
	}
}
